import React from 'react'

import clsx from 'clsx'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { Maybe } from 'src/graphql/types'

import s from './CandidateCardBadgesList.module.scss'

export interface ICandidateCardBadgesListProps {
  title: string
  badges: Array<{
    icon?: Maybe<string> | undefined
    publicName: string
    id: string
  }>
  marginTop?: 'sm' | 'md'
}

export const CandidateCardBadgesList: React.FC<
  ICandidateCardBadgesListProps
> = ({ title, badges, marginTop }) => {
  return (
    <>
      <Typography
        variant={EnumTypographyVariants.H8}
        className={clsx(s.CandidateCardBadgesList__title, {
          [s.CandidateCardBadgesList__title_marginMd]: marginTop === 'md',
          [s.CandidateCardBadgesList__title_marginSm]: marginTop === 'sm',
        })}
        text={title}
      />

      <div className={s.CandidateCardBadgesList__badges}>
        {badges.map(({ icon, publicName }, i) => {
          return (
            <Typography
              key={i}
              variant={EnumTypographyVariants.H9}
              className={s.CandidateCardBadgesList__badge}
              as="div"
            >
              {icon && (
                <div className={s.CandidateCardBadgesList__badgeImg}>
                  <img src={icon} alt="" />
                </div>
              )}

              {publicName}
            </Typography>
          )
        })}
      </div>
    </>
  )
}
